import { Card, CardHeader, CardText, Container, Nav, NavItem } from 'reactstrap'
import { NavLink as NavLinkDom, Outlet } from 'react-router-dom'
import { useFetchSettingsQuery } from './settingApiSlice'
import { Can } from 'context/Acl'
import BreadCrumbs from 'components/breadcrumbs'
import { useLocation, useNavigate } from 'react-router-dom'
import { settingRoutes, profileSetting } from 'routes/settingRoutes'

const SettingView = () => {
  const { data, isLoading, isSuccess } = useFetchSettingsQuery()
  const location = useLocation()
  const navigate = useNavigate()
  
  const allRoutes = [...settingRoutes, ...profileSetting]
  const currentRoute = allRoutes.find(r => r.path === location.pathname)

  return (
    <div className="pb-4 px-3 w-100">
      <div className="d-flex align-items-start gap-2 pt-3">
        {currentRoute ? (
          <BreadCrumbs 
            breadCrumbParent="Pengaturan" 
            breadCrumbParentOnClick={() => navigate(-1)} 
            breadCrumbActive={currentRoute.title} 
          />
        ) : (
          <BreadCrumbs breadCrumbActive={'Pengaturan'} />
        )}
      </div>
      <Card className="w-100 border-0 shadow-sm">
        <CardHeader className="border-bottom-0 bg-transparent">
          <CardText tag="h4" className="pt-3 fw-semibold">
            {currentRoute ? currentRoute.title : 'Pengaturan'}
          </CardText>
          {/* <Nav>
            {settingRoutes.map((item, idx) => (
              <Can I={item.action} this={item.subject} key={idx}>
                <NavItem>
                  <NavLinkDom
                    to={item.path}
                    aria-current="page"
                    className={({ isActive }) => {
                      if (isActive) {
                        return `nav-link active-link`
                      } else {
                        return `nav-link`
                      }
                    }}
                  >
                    {item.name}
                  </NavLinkDom>
                </NavItem>
              </Can>
            ))}
          </Nav> */}
        </CardHeader>
        <Outlet context={[data, isLoading, isSuccess]} />
      </Card>
      <Card
        body
        className="border-0"
        style={{ backgroundColor: 'transparent' }}
      >
        <span className="text-xs text-center mb-1">
          Versi: {process.env.REACT_APP_VERSION}
        </span>
      </Card>
    </div>
  )
}

export default SettingView
